import React, { Component } from 'react';
import Joke from './Joke';
import './css/JokesContainer.css';
import FlipMove from 'react-flip-move';

export default class JokesContainer extends Component {
  render() {
    const jokes = (
      <FlipMove>
        {this.props.jokes.map(joke => (
          <Joke
            key={joke.id}
            id={joke.id}
            text={joke.joke}
            setScore={this.props.setScore}
            score={joke.score}
          />
        ))}
      </FlipMove>
    );

    const loader = (
      <div className="lds-circle">
        <div />
      </div>
    );

    return (
      <div className={`JokesContainer ${this.props.loading && 'loading'}`}>
        {this.props.loading ? loader : jokes}
      </div>
    );
  }
}
